import { Link } from "react-router-dom";

export function NotFoundPage() {
  return (
    <div className="page stack">
      <h1>404</h1>
      <p>Page not found.</p>
      <Link to="/">Go home</Link>
    </div>
  );
}
